import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { supported_cities: ["Pune"], razorpay_enabled: false, razorpay_key_id: null, twilio_enabled: false, commission_pct: 10 };

let cache = null;
let pending = null;

export async function getConfig() {
  if (cache) return cache;
  if (!pending) pending = api.get("/config").then(r => { cache = r.data; return cache; }).catch(() => DEFAULT);
  return pending;
}

export function useConfig() {
  const [cfg, setCfg] = useState(cache || DEFAULT);
  useEffect(() => { let alive = true; getConfig().then(c => { if (alive) setCfg(c); }); return () => { alive = false; }; }, []);
  return cfg;
}
